import { LinkType } from '@easeltv/analytics';
import { MenuLink } from '@easeltv/client-sdk';

import DumbMenuBlock from './MenuBlock.dumb';

/* ---------------------------------- Types --------------------------------- */

interface MenuBlockProps {
    /** Menu items to display */
    items: MenuLink[];

    /** Callback to track menu link clicks */
    trackMenuLinkClicked: (destination: LinkType) => void;
}

/* -------------------------------- Component ------------------------------- */

const MenuBlock = ({ items, trackMenuLinkClicked }: MenuBlockProps) => (
    <DumbMenuBlock items={items} trackMenuLinkClicked={trackMenuLinkClicked} />
);

/* --------------------------------- Export --------------------------------- */

export default MenuBlock;
